import app from "../_app";

[...document.querySelectorAll('.js-slider')].map(slider => {
    const container = slider.querySelector('.js-slider-container');
    const track = slider.querySelector('.js-slider-track');
    const arrowPrev = slider.querySelector('.js-slider-arrow[data-prev]');
    const arrowNext = slider.querySelector('.js-slider-arrow[data-next]');
    const slideTriggers = [...slider.querySelectorAll('.js-slide-trigger')];

    const slides = track.children;

    if(app.viewport.isEqualOrGreaterThan('lg')) {
        if (track.scrollWidth > container.clientWidth) {
            const itemWidth = typeof slides[0] !== 'undefined' ? +slides[0].offsetWidth : 0;
            const itemsToSlide = +slider.dataset.slide || 1;

            const updateCurrent = (newCurrent) => {
                [...slider.querySelectorAll('[data-current]')].map(item => item.removeAttribute('data-current'));
                [...slider.querySelectorAll(`[data-index="${newCurrent}"]`)].map(item => item.setAttribute('data-current', ''));
            }

            const arrowClickHandler = ({currentTarget}) => {
                const slideForward = currentTarget.hasAttribute('data-next');
                const trackStyle = getComputedStyle(track);

                let x = -trackStyle.getPropertyValue('--x').replace('px', '') || 0;

                if (slideForward) {
                    x += itemWidth * itemsToSlide;
                } else {
                    x -= itemWidth * itemsToSlide;
                }

                if (x > track.scrollWidth - container.clientWidth) {
                    x = track.scrollWidth - container.clientWidth;
                } else if (x < 0) {
                    x = 0;
                }

                if (x === 0) {
                    arrowPrev.setAttribute('disabled', '');
                } else {
                    arrowPrev.removeAttribute('disabled');
                }

                if (x === track.scrollWidth - container.clientWidth) {
                    arrowNext.setAttribute('disabled', '');
                } else {
                    arrowNext.removeAttribute('disabled');
                }

                track.style.setProperty('--x', `${-x}px`);
                updateCurrent(x / itemWidth);
            }

            const slideTriggerClickHandler = ({currentTarget: {dataset: {index}}}) => {
                track.style.setProperty('--x', `${-track.children[index].offsetLeft}px`);
                updateCurrent(index);
            }

            if (arrowPrev && arrowNext) {
                arrowPrev.addEventListener('click', arrowClickHandler);
                arrowNext.addEventListener('click', arrowClickHandler);
            }

            slideTriggers.map(slideTrigger => slideTrigger.addEventListener('click', slideTriggerClickHandler));

            // Arrow key navigation (skip for product gallery - it has its own handler)
            if (!slider.classList.contains('js-product-gallery')) {
                const keyboardNavigationHandler = (event) => {
                    if (event.key === 'ArrowLeft' && arrowPrev && !arrowPrev.hasAttribute('disabled')) {
                        event.preventDefault();
                        arrowPrev.click();
                    } else if (event.key === 'ArrowRight' && arrowNext && !arrowNext.hasAttribute('disabled')) {
                        event.preventDefault();
                        arrowNext.click();
                    }
                };

                document.addEventListener('keydown', keyboardNavigationHandler);
            }
        } else {
            if (arrowPrev && arrowNext) {
                arrowPrev.parentElement.removeChild(arrowPrev);
                arrowNext.parentElement.removeChild(arrowNext);
            }
        }
    } else {
        const slideTriggerClickHandler = ({currentTarget: {dataset: {index}}}) => {
            track.scrollTo({left: slides[index].offsetLeft, behavior: 'smooth'});

            slideTriggers.map(slideTrigger => {
                if(slideTrigger.dataset.index === index) {
                    slideTrigger.setAttribute('data-current', '');
                } else {
                    slideTrigger.removeAttribute('data-current')
                }
            });
        }

        slideTriggers.map(slideTrigger => slideTrigger.addEventListener('click', slideTriggerClickHandler));

        // Arrow key navigation for mobile (skip for product gallery - it has its own handler)
        if (!slider.classList.contains('js-product-gallery')) {
            const keyboardNavigationHandlerMobile = (event) => {
                if (event.key === 'ArrowLeft' && arrowPrev && !arrowPrev.hasAttribute('disabled')) {
                    event.preventDefault();
                    arrowPrev.click();
                } else if (event.key === 'ArrowRight' && arrowNext && !arrowNext.hasAttribute('disabled')) {
                    event.preventDefault();
                    arrowNext.click();
                }
            };

            document.addEventListener('keydown', keyboardNavigationHandlerMobile);
        }

        const updateCurrent = (newCurrent) => {
            [...slider.querySelectorAll('[data-current]')].map(item => item.removeAttribute('data-current'));
            [...slider.querySelectorAll(`[data-index="${newCurrent}"]`)].map(item => item.setAttribute('data-current', ''));
        }
        const arrowClickHandlerMobile = ({currentTarget}) => {
            const slideForward = currentTarget.hasAttribute('data-next');
            const itemWidth = typeof slides[0] !== 'undefined' ? +slides[0].offsetWidth : 0;
            const itemsToSlide = +slider.dataset.slide || 1;
            const trackStyle = getComputedStyle(track);

            let x = track.scrollLeft || 0;

            if (slideForward) {
                x += itemWidth * itemsToSlide;
            } else {
                x -= itemWidth * itemsToSlide;
            }

            if (x > track.scrollWidth - container.clientWidth) {
                x = track.scrollWidth - container.clientWidth;
            } else if (x < 0) {
                x = 0;
            }

            if (x === 0) {
                arrowPrev.setAttribute('disabled', '');
            } else {
                arrowPrev.removeAttribute('disabled');
            }

            if (x === track.scrollWidth - container.clientWidth) {
                arrowNext.setAttribute('disabled', '');
            } else {
                arrowNext.removeAttribute('disabled');
            }

            track.scrollLeft = x;
            updateCurrent(x / itemWidth);
        }

        if (arrowPrev && arrowNext) {
            arrowPrev.addEventListener('click', arrowClickHandlerMobile);
            arrowNext.addEventListener('click', arrowClickHandlerMobile);
        }

        track.addEventListener('scroll', (evt) => {
            if(track.scrollLeft >= track.scrollWidth - evt.target.clientWidth){
                arrowNext.setAttribute('disabled', '');
                arrowPrev.removeAttribute('disabled');
            }
            if(track.scrollLeft <= 0){
                arrowNext.removeAttribute('disabled');
                arrowPrev.setAttribute('disabled', '');
            }
        });

        if(slider.querySelector('.js-gallery-dots')) {
            let scrollingTimer;
            track.addEventListener('scroll', (evt) => {
                clearTimeout(scrollingTimer);

                scrollingTimer = setTimeout(() => {
                    updateCurrent(Math.round(track.scrollLeft / container.clientWidth));
                }, 150);

            });
        }


    }
});
